// extracted by mini-css-extract-plugin
export default {"container":"style_container__rUDLe","tabs":"style_tabs__xTLQT","tabOption":"style_tabOption__9xCpZ"};